export const baseUrl =
  window.location.hostname === "localhost"
    ? "https://energy.fetch.ai"
    : window.location.origin;

const agentList = ["agent1", "agent2", "agent3", "agent4", "agent8", "agent9", "agent10", "agent11"];
export const customers = [];
export const sellers = [];

// pomocné mapy
export const customerByPath = {};
export const customerById = {};
export const customerByWallet = {};
export const customerByAgent = {};

export const sellerByPath = {};
export const sellerById = {};
export const sellerByWallet = {};
export const sellerByAgent = {};

function parseCoordinates(coordString) {
  if (!coordString) return { lat: 0, lng: 0 };
  const [lat, lng] = coordString.split(",").map(Number);
  return { lat, lng };
}

let agentsLoaded = false;

export async function loadAllAgents() {
  if (agentsLoaded) return;
  agentsLoaded = true;

  const agentDataMap = {};

  const requests = agentList.map((agentName) =>
    fetch(`${baseUrl}/${agentName}/rest/details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: Math.random().toString(36).substr(2, 9),
        text: ""
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const agent = {
          id: data.id,
          name: data.agentName,
          path: data.path,
          walletAddress: data.walletAddress,
          token: data.baseToken,
          solar: data.solarToken === "" ? null : data.solarToken,
          battery: data.batteryToken === "" ? null : data.batteryToken,
          agentAddress: data.agentAddress,
          location: parseCoordinates(data.mapCoordinates),
          mapInfo: data.mapInfo,
          agentType: data.agentType,
          agentUrl: `${baseUrl}/${agentName}`,
        };

        agentDataMap[agentName] = agent;
      })
      .catch((err) => {
        //console.warn(`Agent ${agentName} did not respond`, err);
      })
  );

  await Promise.all(requests);

  agentList.forEach((agentName) => {
    const agent = agentDataMap[agentName];
    if (!agent) return;

    if (agent.agentType === "SELLER") {
      sellers.push(agent);
      sellerByPath[agent.path] = agent;
      sellerById[agent.id] = agent;
      sellerByWallet[agent.walletAddress] = agent;
      sellerByAgent[agent.agentAddress] = agent;
    } else {
      customers.push(agent);
      customerByPath[agent.path] = agent;
      customerById[agent.id] = agent;
      customerByWallet[agent.walletAddress] = agent;
      customerByAgent[agent.agentAddress] = agent;
    }
  });
}
